<script setup lang="ts">
  import { cva } from 'class-variance-authority'

  withDefaults(
    defineProps<{
      color?: 'red' | 'green'
      shape?: 'default' | 'top-right'
      size?: 'default' | 'destination-card'
    }>(),
    {
      color: 'red',
      shape: 'default',
      size: 'default'
    }
  )

  const bubbleBadgeCva = cva('relative flex shrink-0 items-center justify-center', {
    variants: {
      color: {
        red: 'bg-bt-grabout-red text-white',
        green: 'bg-bt-green text-bt-blue-dark'
      },
      shape: {
        default: 'rounded-bubble',
        'top-right': 'rounded-bubble-top-right'
      },
      size: {
        default: 'size-15 md:size-20 md:py-6',
        'destination-card': 'size-22 py-0 lg:size-16 xl:size-22'
      }
    }
  })
</script>

<template>
  <div :class="bubbleBadgeCva({ color, shape, size })">
    <slot />
  </div>
</template>
